import { useNavigate, useRouteError } from "react-router";
import ErrorUI from "./error-ui";
import { Button } from "./button";

const ErrorBoundary = () => {
    useRouteError();
    const navigate = useNavigate();

    return (
        <ErrorUI
            type="cover"
            description="We ran into an issue and couldn’t complete your request. Please try again."
            actionButtons={[
                <Button key={"reload"} onClick={() => navigate(0)}>
                    Reload page
                </Button>,
            ]}
        />
    );
};
export default ErrorBoundary;
